import { Flex } from "@chakra-ui/react";
import React from "react";

type Props = {
  active?: boolean;
  handleClick: (e: React.MouseEvent) => void;
  children: React.ReactNode;
  icon?: React.ReactNode;
  isAddTab?: boolean;
};

const TabButton: React.FC<Props> = (props) => {
  const { active, handleClick, children, isAddTab, icon } = props;

  const looksActive = isAddTab || active;
  return (
    <Flex
      onClick={handleClick}
      width={isAddTab ? "50px" : "full"}
      flexGrow={isAddTab ? 0 : 1}
      flexShrink={isAddTab ? 0 : undefined}
      pos="relative"
      justifyContent="center"
      p="3"
      cursor="pointer"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="accent"
      roundedTop="xl"
      overflow="hidden"
      alignItems="center"
      borderBottomWidth={active ? 0 : undefined}
      {...(looksActive
        ? {
            borderBottom: "0px",
          }
        : {
            mt: 2,
            boxShadow: "inset 0 -5px 10px rgba(0, 0, 0, 0.1)",
          })}
    >
      {icon && <Flex mr={2}>{icon}</Flex>}
      {children}
    </Flex>
  );
};

export { TabButton };
